import { render, staticRenderFns } from "./UploadCenter.vue?vue&type=template&id=0d7254d0&"
import script from "./UploadCenter.vue?vue&type=script&lang=js&"
export * from "./UploadCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d7254d0')) {
      api.createRecord('0d7254d0', component.options)
    } else {
      api.reload('0d7254d0', component.options)
    }
    module.hot.accept("./UploadCenter.vue?vue&type=template&id=0d7254d0&", function () {
      api.rerender('0d7254d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/UploadCenter.vue"
export default component.exports